import { render, staticRenderFns } from "./ManageBarrelExpiration.vue?vue&type=template&id=d4cfa570&"
import script from "./ManageBarrelExpiration.vue?vue&type=script&lang=js&"
export * from "./ManageBarrelExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports